import React from "react";
import SeoPage from "../../components/SeoPage";
import RELATED from "../../data/related";
import { faqsByTopic } from "../../data/faqs";

export default function FastCsvViewer() {
    return (
        <SeoPage
            title="Fast CSV Viewer — Open Large CSV Files in Seconds"
            description="OpenCSV opens 100,000-row CSV files in milliseconds. Streaming parser, virtualised table — built for speed on any device."
            breadcrumbs={[{ label: "Home", href: "/" }, { label: "Fast CSV Viewer" }]}
            eyebrow="/ feature"
            h1="Open large CSV files. Fast."
            heroLead="Most CSV viewers crawl on big files because they parse and render the whole thing at once. OpenCSV streams the file as it parses and only renders the rows you can actually see — so 100,000 rows feel as fast as 100."
            sections={[
                { heading: "What 'fast' means in real numbers",
                    table: {
                        headers: ["File size", "Rows", "OpenCSV open time"],
                        rows: [
                            ["1 MB", "~10,000", "<200ms"],
                            ["10 MB", "~100,000", "<1.5s"],
                            ["50 MB", "~500,000", "~5s"],
                            ["100 MB+", "1M+", "Use desktop, expect ~10s"],
                        ],
                    },
                    callout: "Numbers measured on a mid-range laptop in Chrome. Mobile is ~30% slower but still smooth for typical files."
                },
                { heading: "Why it's fast",
                    sub: [
                        { heading: "Streaming parser", body: "Instead of loading the whole file into memory and parsing it in one pass, OpenCSV reads rows incrementally. The first thousand rows show on screen before the rest of the file finishes parsing." },
                        { heading: "Virtualised table", body: "We render only the visible rows — typically 30 at a time — and recycle them as you scroll. A 100,000-row file uses about the same DOM weight as 30 rows." },
                        { heading: "No re-renders on edit", body: "Editing a single cell only updates that cell, not the entire grid. Crucial for keeping the UI snappy on long files." },
                    ],
                },
                { heading: "When you'd hit a limit",
                    body: "Browsers cap memory per tab. On a typical laptop you can open files up to ~250 MB before things slow down. For multi-gigabyte CSV files, you genuinely need a desktop tool — try DuckDB or VisiData. OpenCSV is built for the 99% of files under 250 MB.",
                },
                { heading: "Tips for large files",
                    bullets: [
                        "Close other browser tabs before opening a 100 MB+ file (free up RAM)",
                        "Use search to filter to the rows you care about",
                        "Save partial edits to cloud as checkpoints",
                        "On mobile, expect smaller files to render best",
                    ],
                },
            ]}
            faqs={faqsByTopic("large-files", "lightweight", "open")}
            related={[RELATED.viewer, RELATED.editor, RELATED.light, RELATED.use, RELATED.faq, RELATED.impexp]}
        />
    );
}
